var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 284,
    viewBox: "0 0 256 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.003 247.933C256.029 252.924 254.994 257.864 252.966 262.426C250.938 266.987 247.964 271.065 244.241 274.389C240.517 277.714 236.13 280.209 231.37 281.71C226.609 283.211 221.584 283.682 216.627 283.094C198.583 280.424 185.361 264.723 185.801 246.488V36.845C185.365 18.591 198.62 2.88102 216.687 0.240019C221.639 -0.339736 226.658 0.138517 231.411 1.64315C236.165 3.14778 240.545 5.6445 244.261 8.96816C247.978 12.2918 250.946 16.3667 252.97 20.9232C254.994 25.4798 256.028 30.4142 256.003 35.4V247.933V247.933Z",
    fill: "#F9AB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.101 213.193C54.487 213.193 70.202 228.909 70.202 248.294C70.202 267.68 54.487 283.395 35.101 283.395C15.715 283.395 0 267.68 0 248.295C0 228.909 15.715 213.193 35.101 213.193V213.193ZM127.459 106.806C107.982 107.874 92.869 124.212 93.322 143.714V237.999C93.322 263.587 104.581 279.121 121.077 282.432C126.191 283.469 131.472 283.354 136.537 282.096C141.601 280.839 146.322 278.469 150.357 275.161C154.392 271.852 157.64 267.686 159.866 262.966C162.091 258.246 163.238 253.09 163.223 247.872V142.089C163.232 137.413 162.309 132.781 160.508 128.465C158.708 124.149 156.066 120.235 152.737 116.951C149.408 113.667 145.458 111.078 141.118 109.337C136.778 107.595 132.135 106.735 127.459 106.807V106.806Z",
    fill: "#E37400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 284,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/google_analytics.305302b32ec27083aa9c17e00354b45f.svg";
export { ForwardRef as ReactComponent };